import { GraphMutationBuilderPayload, createMutation } from '@camelot/server';

import {
  PurchaseOrderAmendmentCreationPayload,
  PurchaseOrderCreationPayload,
  PurchaseOrderModifierPayload,
} from './dto/purchase-order';
import {
  ReceptionCancellationPayload,
  ReceptionCreationPayload,
  ReceptionModifierPayload,
  ReceptionRowInput,
} from './dto/reception';

export function CREATE_PURCHASE_ORDER(payload: PurchaseOrderCreationPayload): GraphMutationBuilderPayload {
  return createMutation('createPurchaseOrder', {
    props: '',
    type: 'PurchaseOrderCreationPayloadInput!',
    value: payload,
  });
}

export function UPDATE_PURCHASE_ORDER(payload: PurchaseOrderModifierPayload): GraphMutationBuilderPayload {
  return createMutation('updatePurchaseOrder', {
    props: '',
    type: 'PurchaseOrderModifierPayloadInput!',
    value: payload,
  });
}

export function CREATE_PURCHASE_ORDER_AMENDMENT(
  payload: PurchaseOrderAmendmentCreationPayload
): GraphMutationBuilderPayload {
  return createMutation('createPurchaseOrderAmendment', {
    props: '',
    type: 'PurchaseOrderAmendmentCreationPayloadInput!',
    value: payload,
  });
}

export function VALIDATE_PURCHASE_ORDER(purchaseOrderId: string): GraphMutationBuilderPayload {
  return createMutation('validatePurchaseOrder', {
    argument: 'purchaseOrderId',
    props: '',
    type: 'UUID!',
    value: purchaseOrderId,
  });
}

export function CANCEL_PURCHASE_ORDER(purchaseOrderId: string): GraphMutationBuilderPayload {
  return createMutation('cancelPurchaseOrder', {
    argument: 'purchaseOrderId',
    props: '',
    type: 'UUID!',
    value: purchaseOrderId,
  });
}

export function CREATE_RECEPTION(payload: ReceptionCreationPayload): GraphMutationBuilderPayload {
  return createMutation('createReception', {
    args: { payload: { type: 'ReceptionCreationPayloadInput!', value: payload } },
    props: '',
  });
}

export function UPDATE_RECEPTION(payload: ReceptionModifierPayload): GraphMutationBuilderPayload {
  return createMutation('updateReception', {
    args: { payload: { type: 'ReceptionModifierPayloadInput!', value: payload } },
    props: '',
  });
}

export function UPDATE_RECEPTION_ROWS(receptionId: string, rows: ReceptionRowInput[]): GraphMutationBuilderPayload {
  return createMutation('updateReceptionRows', {
    args: {
      receptionId: { type: 'UUID!', value: receptionId },
      rows: { type: '[ReceptionRowInput!]!', value: rows },
    },
    props: '',
  });
}

export function VALIDATE_RECEPTION(receptionId: string): GraphMutationBuilderPayload {
  return createMutation('validateReception', {
    args: { receptionId: { type: 'UUID!', value: receptionId } },
    props: '',
  });
}

export function CANCEL_RECEPTION(payload: ReceptionCancellationPayload): GraphMutationBuilderPayload {
  return createMutation('cancelReception', {
    args: { payload: { type: 'ReceptionCancellationPayloadInput!', value: payload } },
    props: '',
  });
}

export function LINK_PURCHASE_ORDERS_TO_RECEPTION(
  receptionId: string,
  purchaseOrderIds: string[]
): GraphMutationBuilderPayload {
  return createMutation('linkPurchaseOrdersToReception', {
    args: {
      purchaseOrderIds: { type: '[UUID!]!', value: purchaseOrderIds },
      receptionId: { type: 'UUID!', value: receptionId },
    },
    props: '',
  });
}

export function UNLINK_PURCHASE_ORDER_FROM_RECEPTION(
  receptionId: string,
  purchaseOrderId: string
): GraphMutationBuilderPayload {
  return createMutation('unlinkPurchaseOrderFromReception', {
    args: {
      purchaseOrderId: { type: 'UUID!', value: purchaseOrderId },
      receptionId: { type: 'UUID!', value: receptionId },
    },
    props: '',
  });
}
